































































import Vue from "vue";
import Component from "vue-class-component";
import { Service as ServiceInterface } from "../../services/service/entities/service.interface";
import Service from "../../components/client/Service.vue";
import { Watch } from "vue-property-decorator";
import constants from "../../config/constants";

@Component({
  components: {
    Service
  }
})
export default class Services extends Vue {
  page = 1;
  loadingServices = false;

  private mounted(): void {
    window.scrollTo(0, 0);
    this.loadingServices = true;
    this.page = parseInt(this.$route.params.id);
    this.$store
      .dispatch("service/getServicesToClient", {
        start:
          parseInt(this.$route.params.id) == 1
            ? 0
            : parseInt(this.$route.params.id) *
                constants.ITEMS_PER_PAGE_CLIENT -
              constants.ITEMS_PER_PAGE_CLIENT,
        quantity: constants.ITEMS_PER_PAGE_CLIENT
      })
      .finally(() => {
        this.loadingServices = false;
      });
  }

  private get services(): Array<ServiceInterface> {
    const services = this.$store.getters["service/getServices"];

    const result = services.filter(
      (service: ServiceInterface) =>
        service.serviceStatus == constants.STATUS.ACTIVE
    );

    return result;
  }

  private get totalServices(): number {
    const totalServices = this.$store.getters["service/getTotalServices"];
    return totalServices;
  }

  @Watch("page")
  private getServices(): void {
    this.loadingServices = true;
    this.$store
      .dispatch("service/getServicesToClient", {
        start:
          this.page * constants.ITEMS_PER_PAGE_CLIENT -
          constants.ITEMS_PER_PAGE_CLIENT,
        quantity: constants.ITEMS_PER_PAGE_CLIENT
      })
      .finally(() => {
        window.scrollTo(0, 0);
        this.loadingServices = false;
        if (this.page !== parseInt(this.$route.params.id)) {
          this.$router.push(`/services/${this.page}`);
        }
      });
  }

  private get totalPages(): number {
    const services = this.totalServices;
    const total = services / constants.ITEMS_PER_PAGE_CLIENT;
    if (total > Math.round(total)) {
      return Math.round(total) + 1;
    } else {
      return Math.round(total);
    }
  }
}
